<script>
import AppTable from "../form-generator/AppTable.vue";
import axios from "axios";
import {VueFinalModal} from "vue-final-modal";
import LessonF from "./lesson-form.vue";
import LessonInstanceForm from "./lesson-instance.vue";
/*1. kalendář ve stylu KK - je pondělí až pátek a od 17:00 - 21:00
2. pole musí obsahovat
- úroveň slovně (bývá typu B1- od 1/2 , A1- atd.)
- den se psát nemusí, ale čas té lekce například 17:00
- jméno lektora (můžeme použít pro vyhledávání ty lektory z KK - jsou tam stejní)
- počet volných míst 4 je max a jakmile už tam budou 4 místa zaplacená, tak už tam nikoho nepustit. Je ale potřeba, aby se to místo zabookovalo už v moment, jak ten dotyčný klikne na to Objednat Onlajnovku (viz níže) protože jinak by se mohlo stát, že tam kliknou třeba 2 lidi naráz a přihlásilo by se nám tam víc lidí než jen 4. Bylo by super kdyby tam admin mohl místo zabookovat i ručně sám...
- cena Onlajnovky - viz produkty Onlajnovky (2580 Kč)
- tlačítko OBJEDNAT Onlajnovku

V obj. formuláři prosím aby to bylo pod brandem Onlajnovka (logo v příloze máš ho v modré i v bílé verzi, nevím které tam bude vypadat líp graficky)
*/

import SemesterF from "./semester-form.vue";

export default {
  name: "lekce",
  props: ['admin', 'user'],
  components: {AppTable, VueFinalModal, LessonF, SemesterF, LessonInstanceForm},
  data() {
    return ({
      appTableReady:false,
      lesson:{product_id:null, day:null, hour:null, lector_id:null, capacity: 4, semester_id: null},
      semesters:[],
      current_semester:null,
      semester: {name:'', start_date:'', end_date:'', id:null},
      fields: [
        {
          "label": "úroveň slovně",
          "type": "text",
          "codename": "level_name"
        },{
          "label": "jméno lektora",
          "type": "text",
          "codename": "lector_name"
        },
        {
        "label": "den",
        "display_filter": 'wday',
          "codename": "day"
        },
        {
          label: 'čas',
          codename: 'hour',
          display_filter: 'hour'
        },
        {
          label: 'Kapacita',
          codename: 'capacity',
        },
        {
          label: 'Volná místa',
          codename: 'available_places',
        },
        {label: "Počet odučených lekcí", codename: "lesson_instances_count"},
      /*  {
          label: 'Product',
          codename: 'product_name',
        }*/
      ],
      app: {
        data_url: '/onlajnovka/lessons-all.json',
        destroy_url: '/onlajnovka/lessons/:id',

        actions: this.admin ? ['delete']: [],

        hidden_id: true,

      },
      filters:[
        {
          type:'select',
          label:'Semestr', codename:'semester',
          options:[]
        },
        (!this.admin ? {
          type:'select',
          label:'Lektor',
          codename:'zaskok',
          default:'m',
          options:[
              {value:'m', label:'Moje lekce'},
              {value:'all', label:'Zadat záskok'}
          ],
        } : {})
      ]
    })
  },
  mounted() {
    this.loadSemesters();


  },
  methods:{
    loadSemesters(){
      axios.get('/onlajnovka/semesters.json').then((response)=>{
        this.semesters = response.data.items
        this.current_semester = response.data.current
        this.filters[0].options = response.data.items.map((semester)=>{
          return {value: semester.id, label: semester.name}
        })
        if(this.filters[0].options.length>0){
          if (this.current_semester){
            this.filters[0].default = this.current_semester.id
          } else {
            this.filters[0].default = this.filters[0].options[0].value
          }
        }
        //this.filters[0].options.unshift({value: '', label: ' - Všechny semestry  -'})

        this.appTableReady= true
        //this.$refs.appTable.setFilterDefaultValues()
        //this.$refs.appTable.refresh()
      })
    },

    handleItemClick(){

    },
    handleAddLesson(){
      this.lesson = {product_id:null, day:null, hour:null, lector_id:null, capacity: 4, id: null, level_name:'', semester_id: this.current_semester ? this.current_semester.id : null}


      this.$refs.lessonform.showModal()
    },
    handleLessonUpdated(){
     // this.$refs.lessonform.hideModal()
      this.$refs.appTable.refresh()
    },


    editLesson(lesson){
      this.lesson = JSON.parse(JSON.stringify(lesson))
      this.$refs.lessonform.showModal()



    },
    addLessonInstance(lesson){
      this.lesson = lesson
      this.$refs.lessoninstanceform.showModal()
    },
    handleAddSemester(){
      this.$refs.semesterform.showModal()

    },
    actions_arr(){
      //[{       label: 'upravit', method: editLesson },        {label: 'Zaznamenat lekci', method: addLessonInstance}]
      return this.admin ? [
        {label: 'Upravit', method: this.editLesson},
        {label: 'Zaznamenat lekci', method: this.addLessonInstance}
      ] : [{label: 'Zaznamenat lekci', method: this.addLessonInstance}]
    },
    onInstanceSaved(){
      this.$refs.appTable.refresh()
    }

  }

}
</script>

<template>


  <h2>Onlajnovka</h2>
  <div class="card card-body index p-0">

    <div class="ml-auto" v-if="admin">
      <button @click.prevent="handleAddLesson" class="btn btn-sm btn-success">Přidat lekci </button>

      <button @click.prevent="handleAddSemester" class="btn btn-sm btn-warning">Upravit / přidat semestr</button>

    </div>

    <AppTable :app="app" :fields="fields"  v-if="appTableReady"
              :filters="filters"
              @itemClick="handleItemClick" ref="appTable"
              :actions="actions_arr()"

    ></AppTable>
  </div>

  <lesson-f ref="lessonform" :lesson="lesson" @saved="handleLessonUpdated" :current_semester="current_semester" :semesters="semesters" ></lesson-f>

  <semester-f ref="semesterform" @semester-updated="loadSemesters" :semesters="semesters"></semester-f>

  <lesson-instance-form ref="lessoninstanceform" :lesson="lesson"  @lessonSaved="onInstanceSaved" :current_user="user" :admin="admin"></lesson-instance-form>

</template>

<style scoped>

</style>